import { __exports as container } from './_virtual-container2.js';
import { __require as requireMustacheService } from './vp-js-token-engine-build-services-mustacheService.js';
import { __require as requireFormatter } from './vp-js-token-engine-build-services-formatter.js';
import { __require as requireCultureFormatter } from './vp-js-token-engine-build-services-cultureFormatter.js';
import { __require as requireUrlClient } from './vp-js-token-engine-build-services-urlClient.js';
import { __require as requireContextService } from './vp-js-token-engine-build-services-contextService.js';
import require$$5 from './_virtual-liquid.browser.js';

var hasRequiredContainer;

function requireContainer () {
	if (hasRequiredContainer) return container;
	hasRequiredContainer = 1;

	Object.defineProperty(container, "__esModule", {
	  value: true
	});
	container.urlClientFactory = container.mustacheService = container.formatterService = container.engine = container.cultureFormatter = container.contextService = void 0;
	var _mustacheService = requireMustacheService();
	var _formatter = requireFormatter();
	var _cultureFormatter = requireCultureFormatter();
	var _urlClient = requireUrlClient();
	var _contextService = requireContextService();
	var _liquidjs = require$$5;
	container.formatterService = new _formatter.FormatterService();
	container.mustacheService = new _mustacheService.MustacheService();
	container.cultureFormatter = new _cultureFormatter.CultureFormatter();
	container.contextService = new _contextService.ContextService();
	container.engine = new _liquidjs.Liquid({
	  strictVariables: false,
	  cache: true
	});
	container.urlClientFactory = {
	  create: () => new _urlClient.UrlClient()
	};
	
	return container;
}

export { requireContainer as __require };
//# sourceMappingURL=vp-js-token-engine-build-infrastructure-container.js.map
